import PropTypes from "prop-types";
// @mui
//
import { useState } from "react";
import Iconify from "../../components/Iconify";
import {
  IconButton,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  FormControlLabel,
  Radio,
  RadioGroup,
  FormControl,
  TextField,
} from "@mui/material";

import { useDispatch } from "react-redux";
import { editObject } from "../reducers/slices/phases.js";

// ----------------------------------------------------------------------

export default function ObjectSettings(props) {
  const dispatch = useDispatch();
  let [open, setOpen] = useState(false);
  return (
    <>
      <IconButton onClick={() => setOpen(true)}>
        <Iconify icon={"eva:options-2-outline"} width={20} height={20} />
      </IconButton>
      <Dialog
        fullWidth
        maxWidth={"xs"}
        open={open}
        onClose={() => {
          setOpen(false);
        }}
      >
        <DialogTitle>Text Settings</DialogTitle>
        <DialogContent dividers>
          <Box>
            <FormControl>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="female"
                name="radio-buttons-group"
                value={props.action.animationType}
                onChange={(event) =>
                  dispatch(
                    editObject({
                      actionId: props.action.id,
                      changes: { animationType: event.target.value },
                    })
                  )
                }
              >
                <FormControlLabel
                  value="end"
                  control={<Radio />}
                  label="Show until the end of the current phase"
                />
                <FormControlLabel
                  value="pause"
                  control={<Radio />}
                  label="Pause animations for specific time to show this object"
                />
              </RadioGroup>
              {props.action.animationType === "pause" && (
                <TextField
                  sx={{ mt: 3 }}
                  id="outlined-number"
                  label="Length of Pause (seconds)"
                  type="number"
                  value={props.action.pause}
                  inputProps={{
                    step: 0.5,
                  }}
                  onChange={(event) =>
                    dispatch(
                      editObject({
                        actionId: props.action.id,
                        changes: { pause: Number(event.target.value) },
                      })
                    )
                  }
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              )}
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{ boxShadow: "none" }}
            variant="contained"
            color="primary"
            onClick={() => setOpen(false)}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
      {/*
      <MenuPopover
        disabledArrow={disabledArrow}
        open={Boolean(open)}
        anchorEl={open}
        onClose={onClose}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        arrow={arrow}
        sx={{
            boxShadow:100,
          mt: -1,
          width: width,
          "& .MuiMenuItem-root": {
            px: 1,
            typography: "body2",
            borderRadius: 0.75,
            "& svg": { mr: 2, width: 20, height: 20 },
          },
          ...popoverSx,
        }}
      >
        <Box>
          <Box sx={{fontSize:14,fontWeight:700,textAlign:"center",mt:0.5,mb:2}}>Object Settings</Box>
          <FormGroup sx={{fontSize:16}}>
            <FormControlLabel
              control={<Checkbox />}
              label="Show until the end of phase"
            />
          </FormGroup>
        </Box>
    </MenuPopover> */}
    </>
  );
}
